module.exports = __webpack_public_path__ + "assets/edae25c368c106182739ee61ae7262ac.mp4";